import { WebLink } from '@news-mono/web-common'
import React from 'react'
import { StyledLogo } from '../../../section-header/SectionHeader/SectionHeaderLogo/SectionHeaderLogo.styled'

const spotlightSectionHeaderLogo = require('./assets/spotlight-section-header-logo.jpg')
const sunriseSectionHeaderLogo = require('./assets/sunrise-section-header-logo.png')
const theMorningShowSectionHeaderLogo = require('./assets/the-morning-show-section-header-logo.png')

interface SectionHeaderLogoProps {
    section: string
    sectionUrl?: string
}

export const SectionHeaderLogo: React.FC<SectionHeaderLogoProps> = ({
    section,
    sectionUrl,
}) => {
    const logo = sectionLogo(section)
    if (!sectionUrl) {
        return logo
    }
    return <WebLink to={sectionUrl}>{logo}</WebLink>
}

function sectionLogo(section: string) {
    switch (section) {
        case 'spotlight': {
            return (
                <StyledLogo alt="Spotlight" src={spotlightSectionHeaderLogo} />
            )
        }
        case 'sunrise': {
            return <StyledLogo alt="Sunrise" src={sunriseSectionHeaderLogo} />
        }
        case 'the-morning-show': {
            return (
                <StyledLogo
                    alt="The Morning Show"
                    src={theMorningShowSectionHeaderLogo}
                />
            )
        }

        default:
            return null
    }
}
